import { NavSection } from "src/components/layout/nav/nav-section";

import { Icon } from "src/components/layout/nav/icons/intelligence";
import { ActiveSectionProps } from "src/components/layout/nav/utils";
import { useIntelligenceSection } from "./hooks/intelligence";

export const Intelligence = (props: ActiveSectionProps) => {
  const section = useIntelligenceSection();
  return <NavSection icon={Icon} {...section} {...props} />;
};
